import { render } from "./TestSn.vue?vue&type=template&id=515e5e6b&scoped=true"
import script from "./TestSn.vue?vue&type=script&lang=js"
export * from "./TestSn.vue?vue&type=script&lang=js"

import "./TestSn.vue?vue&type=style&index=0&id=515e5e6b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-515e5e6b"]])

export default __exports__